/**
 * @flow
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';

type PayButtonProps = {
    loading: boolean,
    disabled: boolean,
    onPay: Function,
};

const PayButton = ({ loading, disabled, onPay }: PayButtonProps) => (
    <Button
        onClick={onPay}
        loading={loading}
        disabled={disabled || loading}
        color="green"
        floated="right"
    >
        <Icon name="dollar" />
        <FormattedMessage
            id="pages.appointments.details.invoice.InvoiceForm.pay"
            defaultMessage="Pay"
        />
    </Button>
);

export default PayButton;
